import { render, staticRenderFns } from "./LearningOutcome.vue?vue&type=template&id=46c71880&scoped=true&"
import script from "./LearningOutcome.vue?vue&type=script&lang=js&"
export * from "./LearningOutcome.vue?vue&type=script&lang=js&"
import style0 from "./LearningOutcome.vue?vue&type=style&index=0&id=46c71880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c71880",
  null
  
)

export default component.exports